export default () => ({
  mixins: [],
  data() {
    return {
      backupData: {},
      panelArr: [],
      openDefault: [],
      form: {}, // 表单集合
      labelList: [],
      tabForm: {}, // 子表表单集合
      tabBtn: {}, // 子表按钮集合
      cacheMainTable: {}, // 记录主表的数据
    }
  },
  watch: {},
  created() {},
  updated() {},
  mounted() {},
  methods: {
    // 主表按钮权限控制
    fetchActionsInCustomizePage({ objId, params, btnConfig, isFillBtn, fillIndex = 0, filterBtns=[] }, cb) {
      const fillCb = (btnConfig, btns = []) => {
        if (btns.length) {
          let fillBtn = []
          btns.forEach(btn => {
            let isExist = btnConfig.buttons.some(i => i.webname == btn.webname)
            if (!isExist) {
              fillBtn.push({
                ...btn,
                text: btn.webdesc,
                isShow: objId != -1,
                btnclick: () => {
                  const newItem = { ...btn, objId }
                  typeof this[btn.webname] == 'function' ? this[btn.webname](newItem) : this.buttonClick(newItem)
                },
              })
            }
          })
          fillBtn = fillBtn.concat([{
            webname: 'fix',
            text: t('刷新'),
            btnclick: () => {
              this.refresh();
            },
          },
          {
            webname: 'fix',
            text: t('返回'),
            btnclick: () => {
              this.back();
            },
          }])
          fillBtn.length && btnConfig.buttons.splice(fillIndex, 0, ...fillBtn)
        }
      }
      this.service.common.fetchActionsInCustomizePage(params).then(res => {
        if (res.data.code == 0) {
          if (isFillBtn) {
            const btns = res.data.data.filter(i => !filterBtns.includes(i.webname))
            fillCb(btnConfig, btns)
          } else {
            btnConfig.buttons.filter(i => i.webname != 'fix').forEach((item, index) => {
              let actionbtn = res.data.data.find(i => i.webname == item.webname)
              let btn = { ...item, ...actionbtn, text: item.text || actionbtn.webdesc, isShow: !!actionbtn }
              !btn.hasOwnProperty('btnclick') && (btn.btnclick = () => { this[btn.webname](btn) })
              btnConfig.buttons.splice(index, 1, btn)
            })
          }
          this.$nextTick(() => {
            typeof cb == 'function' && cb()
            this.modifyCustomizedPageDecryption();
          })
        }
      })
    },
    // 主表表单
    async getObject(args, cb) {
      let base = {}
      let panelArr = []
      let openDefault = []
      this.loading = true
      const data = await $utils.getObject(args.tableName, args.objId);
      this.loading = false
      data.addcolums.forEach((i, index) => {
        if (i.parentname == args.parentname || i.parentdesc == t('日志')) return // 表单过滤日志
        panelArr.push({ parentdesc: i.parentdesc, parentname: i.parentname })
        if (i.hrdisplay == 'expand') openDefault.push(i.parentname)
        this.$set(this.form, i.parentname, {
          ...$utils.initFormConfig(i.childs, {}, '!=', { valForSelect: true, isBackRowItem: true, styleSpan: args.styleSpan }),
          isGrid: true,
        });
        this.fillColumns && this.fillColumns(i)
        Object.assign(base, this.form[i.parentname].formValue)
      })
      this.cacheMainTable = {tableName: args.tableName, itemId: args.objId, addcolums: data.addcolums};
      this.panelArr = panelArr
      this.openDefault = openDefault
      this.backupData.base = base
      typeof cb == 'function' && cb(base, this.form)
      setTimeout(() => {
        $(`.${args.tableName} .obj-form .ark-collapse-item:not(.ark-collapse-item-active)`).each(function(index, i){
          $(i).find('.ark-collapse-header').click()
        })
      }, 300)
    },
    // 子表Tab
    async objectTab(args, cb) {
      const formdata = new FormData();
      formdata.append('table', args.tableName);
      formdata.append('objid', args.objId);
      formdata.append('ismaintable', 'y');
      const { data } = await this.service.inventoryCenter.objectTab(formdata)
      if (data.code === 0) {
        let arr = data.data.reftabs
        .sort((a, b) => (a.order - b.order))
        .map((tab, index) => {
          this.$set(this.tabForm, tab.tablename, { formData: [], formValue: {}, isGrid: true, key: tab.tablename })
          const item = {
            tablename: tab.tablename,
            label: tab.tabledesc,
            value: tab.tablename,
            objid: args.objId,
            index,
            isShow: true,
            isNew: args.objId == -1,
            hasInit: false, // 表格是否已初始化， 控制子表挂载
            ref: {
              table: tab.tablename,
              refcolid: tab.refcolid,
              searchdata: {
                column_include_uicontroller: true,
                orderby: [{ column: `${tab.tablename}.ID`, asc: false }],
                range: 10,
                startindex: 0
              }
            },
            tableConfig: {
              height: 400,
              isShowSelection: false, // 是否显示checkedbox
              selectedData: [],
              totalData: [], // 总计
            }
          }
          typeof cb == 'function' && Object.assign(item, cb(tab))
          return item
        })
        this.labelList = arr
        this.labelClick(arr.filter(i => i.isShow)[0])
      }
    },
    // 子表表单
    inputForitem(table, enterCb) {
      const fromdata = new FormData();
      fromdata.append('table', table);
      fromdata.append('inlinemode', 'Y');
      this.service.common.publicUrlParams('/p/cs/inputForitem', fromdata).then((res) => {
        if (res.data.code === 0 && res.data.data.inpubobj) {
          this.$set(this.tabForm, table, {
            ...$utils.initFormConfig(res.data.data.inpubobj, this.tabForm[table], '!=', { valForSelect: true, isBackRowItem: true }),
            key: Date.now(),
          })
          const reg = /^[1-9]\d*$/;
          const reg2 = /^\d*\.{0,1}\d{0,4}$/
          this.tabForm[table].formData.forEach(item => {
            if (item.style == 'input') {
              item.inputenter = () => enterCb()
            }
            if (item.value.match(/^(QTY.*|.*QTY)$/)) {
              item.regx = reg
            }
            if (item.value.match(/^(AMT.*|.*AMT)$/)) {
              item.regx = reg2
            }
            // 外键关联字段事件
            if (item.itemdata) {
              item.oneObj = (e) => {
                console.log(e);
                this.tabForm[table].formValue[item.value] = e.ID || ''
                this.tabForm[table].formValue[item.value.replace(/_ID$/, '_ECODE')] = e.rowItem && e.rowItem.ECODE ? e.rowItem.ECODE.val : ''
                this.tabForm[table].formValue[item.value.replace(/_ID$/, '_ENAME')] = e.rowItem && e.rowItem.ENAME ? e.rowItem.ENAME.val : ''
              }
            }
          })
        }
      });
    },
    // 子表按钮
    async objectTabBtn(args, cb) {
      const formdata = new FormData();
      formdata.append('table', args.tableName);
      formdata.append('objid', args.objId);
      formdata.append('ismaintable', 'n');
      const { data } = await this.service.inventoryCenter.objectTab(formdata)
      if (data.code === 0) {
        let btns = []
        const { tabcmd, tabwebact } = data.data
        if (tabcmd.cmds && tabcmd.cmds.length) { // 标准按钮
          const map = { actionMODIFY: t('保存'), actionDELETE: t('删除明细'), actionIMPORT: t('导入')}
          tabcmd.cmds.forEach((item, index) => {
            if (item === 'actionMODIFY' || item === 'actionDELETE') {
              if (tabcmd.prem[index]) {
                btns.push({
                  webname: item,
                  text: map[item],
                  isShow: true,
                  type: 'primary',
                  btnclick: () => { 
                    this[item]({ table: args.tableName, webname: item })
                  }
                })
              }
            }
          });
        }
        if (tabwebact.objtabbutton && tabwebact.objtabbutton.length) { // 动作定义
          tabwebact.objtabbutton.forEach((item) => {
            btns.push({ 
              ...item, 
              text: item.webdesc,
              type: 'primary',
              btnclick: () => { 
                const newItem = { ...item, objId: args.objId }
                typeof this[item.webname] == 'function' ? this[item.webname](newItem) : this.buttonClick(newItem)
              }
            })
          });
        }
        typeof cb == 'function' && (btns = cb(btns))
        Object.assign(this.tabBtn, { 
          [args.tableName]: {
            typeAll: 'default', // 按钮统一风格样式
            btnsite: 'left',
            buttons: btns,
          }}
        )
        this.$forceUpdate()
      }
    },
    buttonClick(obj) {
      this.beforeApi(obj, (...args) => {
        const { vuedisplay } = obj
        switch (vuedisplay) {
          case "slient":
            this.webActionSlient(...args);
            break;
          case "dialog":
            this.objTabActionDialogNew(...args);
            break;
          case "js":
            this.webActionJs(...args)
            break;
          default:
            break;
        }
      })
    },
    beforeApi(obj, cb) {
      let params = {};
      const selection = this.$refs[this.labelDefaultValue][0].tableConfig.selectedData
      const selectIdArr = selection.map(i => i.ID)
      params = {
        ids: selectIdArr,
        selection,
      }

      if (obj.confirm) { // 有提示
        if (obj.confirm.indexOf('{') >= 0) {
          const {
            isselect = false,
            isradio = false,
            radiodesc = '',
            desc = '',
            nodesc = '',
            checked = false,
            checkurl = '' } = JSON.parse(obj.confirm)

          if (isselect) {
            if (selectIdArr && selectIdArr.length === 0) { // 请选中
              $fcError({
                content: t('请选择数据执行【{}】操作！', obj.webdesc)
              });
            } else if (isradio && selectIdArr.length !== 1) { // 仅单选
              $fcError({
                content: t('只能选择一条数据执行【{}】操作！', obj.webdesc)
              });
            } else if (desc) { // 二次确认
              $fcWarn({
                content: t('确认执行【{}】操作吗？', obj.webdesc),
                showCancel: true,
                onOk: () => {
                  cb.call(this, obj, params);
                }
              });
            } else if (checked) { // 有二次校验逻辑(api)
              const _params = {
                id: selectIdArr.join(),
                ids: selectIdArr
              }
              this.service.common.publicUrlParams(checkurl, _params).then((res) => {
                if (res.data.code === 10) {
                  $fcWarn({
                    content: res.data.message,
                    mask: true,
                    showCancel: true,
                    onOk: () => {
                      cb.call(this, obj, { ...res, ...params });
                    }
                  });
                } else if (res.data.code === 0) {
                  cb.call(this, obj, { ...res.data, ...params });
                }
              });
            } else {
              // 参数都不存在,直接执行
              cb.call(this, obj, params);
            }
          } else {
            $fcWarn({
              content: `${desc}`
            });
          }
        } else {
          $fcWarn({
            content: `${obj.confirm}`
          });
        }
      } else {
        cb.call(this, obj, params);
      }
    },
    webActionSlient(obj, params) {
      this.service.common.publicUrlParams(obj.action, params).then((res) => {
        const { code, message } = res.data
        if (code === 0) {
          this.$Message.success(message)
          this.refresh()
        }
      });
    },
    async objTabActionDialogNew(tab, params) { // 动作定义弹出框
      console.log(tab)
      const url = tab.action;
      const index = url.lastIndexOf('\/');
      let componentName = url.substring(index + 1, url.length);
      let component = null
      if ($BC.Components[componentName]) {
        component = $BC.Components[componentName]
      } else {
        const res = await import(`@/views/modal/orderCenter/${componentName}.vue`)
        component = res.default
      }
      this.publicBouncedConfig = {
        title: `${tab.webdesc}`,
        titleAlign: 'left',
        url: component,
        name: componentName,
        width: component.props.dialogWidth || '900',
        componentData: {
          tableName: vm.$route.params.customizedModuleName,
          ...tab,
          ...params
        }
      };
      setTimeout(() => {
        this.$children.find(item => item.name === componentName).openConfirm();
      }, 100);
    },
    webActionJs(obj) {
      if(obj.action === 'DECRYPTION') {
        this.DECRYPTION(obj);
      }
    },
    // 解密按钮
    DECRYPTION(obj) {
      console.log(obj)
      console.log(this.form)
      const { authUrls } = obj.cuscomponent && JSON.parse(obj.cuscomponent) || {};
      const { tableName, itemId, addcolums } = this.cacheMainTable;
      let decryptionCols = {};
      addcolums.forEach(cols => {
        cols.childs.forEach(col => {
          if(col.webconf && col.webconf.isNeedDecrypt) {
            decryptionCols[col.colname] = col.valuedata
          }
        })
      })
      console.log(addcolums)
      const params = {
        table: tableName,
        data: {
          [tableName]: { ID: itemId, ...decryptionCols }
        }
      }
      this.$R3loading.show(tableName)
      this.service.common.publicUrlParams(authUrls.url, params).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(t('解密成功'))
          const data = res.data.data.columns;
          data.forEach(item => {
            Object.keys(this.form).forEach(key => {
              if(item.colname in this.form[key].formValue) {
                this.form[key].formValue[item.colname] = item.valuedata;
              }
            })
          });
          this.modifyCustomizedPageDecryption(true); // 小眼睛
        }
      }).finally(() => {
        this.$R3loading.hide(tableName);
      })
      
    },
    // 修改自定义页面的解密按钮文案 => 仿照css.handle.js的cusBtnText方法
    modifyCustomizedPageDecryption(isEyeOpen) {
      this.$nextTick(() => {
        $('button.ark-btn.ark-btn-default').each(function(index, item){
          if (item.innerHTML.includes('decryption') || item.innerHTML.includes('iconios-eye')) {
            item.innerHTML = `<i class="ark-icon iconfont ${isEyeOpen ? 'iconios-eye' : 'iconios-eye-off'} iconfont" style="font-size: 20px;line-height: 1;"></i> `
          }
        })
      })
    },
  }
})